// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1704":"39ef9eb4","5173":"39ef9eb4"}[chunkId] + ".chunk.css";
};